import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import BtnSubmit from '../Buttons/BtnSubmit';
import { Container, Row, Col } from 'reactstrap';
import defaultError from './images/defaultError.svg';
import { connect } from 'react-redux';

const failureScreen = (props) => {
  const [error, setError] = useState('null');

  useExtendedEffect((runSideEffects) => {
    const errorId = props.errorId ?? '0';
    const homePageId = props.cmsContent.ids[0];
    const errorList = props.cmsContent.items[homePageId].content.errorMessages?.expandedValue[0]?.errors?.value;
    let error = errorList?.find(error => error.id == errorId);
    if (!error) {
      error = errorList.find(error => error.id == 0);
    }
    setError(error);
  }, []);

  return (
    <Container className='failure-screen' data-error-id={props.errorId} data-description={props.description}>
      <Row className='justify-content-md-center'>
        <Col xs={12} md={12}>
          <div className='title'>
            <div className='title-bold'>
              <h2>{error.titleBold}</h2>
            </div>
            <div className='title-Regular'>
              <h3>{error.subTitle}</h3>
            </div>
          </div>
        </Col>
      </Row>
      <Row className='justify-content-md-center'>
        <Col xs={12} md={12}>
          <div className='img-wrapper'>
            {props.imageName ? <Image className='img-wrapper' src={require(`./images/${props.imageName}.png`)} alt='' /> : <Image src={defaultError} alt='' />}
          </div>
        </Col>
      </Row>
      <Row className='justify-content-md-center'>
        <Col xs={12} md={12}>
          <div className='description'>
            <div dangerouslySetInnerHTML={{ __html: error.message }} />
          </div>
        </Col>
      </Row>
      <Row className='justify-content-md-center'>
        <Col xs={12} md={12}>
          <div className="btn-wrapper">
            <BtnSubmit formid='failure-screen' onclick={props.onclick} text={error.buttonText}></BtnSubmit>
          </div>
        </Col>
      </Row>
      <Row className='justify-content-md-center'>
        <Col xs={12} md={12}>
          <div className='bottom-link'>
            {props.bottomLinkText ? (
              <p>
                <a href={props.object.bottomLinkUrl}>{props.object.bottomLinkText}</a>
              </p>
            ) : (
              ''
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    cmsContent: state.iContentRepo,
  }
}
export default connect(mapStateToProps, null)(failureScreen)

